import { iHolidayQuoteContentBlocks } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";

export function buildPreviewWhatsIncludedBlock(): iHolidayQuoteContentBlocks {
  return {
    id: "preview-whats-included",
    type: "inclusions",
    title: "",
    body: "",
    gallery: [],
    inclusionsData: {
      sectionTitle: "What's Included",
      inclusions: [
        {
          id: "preview-inclusions-flights",
          category: "Flights / Transfers / Accommodation / Meal Basis",
          items: [
            {
              id: "preview-inc-flight",
              text: "✈️ Return Business Class flights from London Heathrow to Malé via Doha",
              included: true,
              details: "",
            },
            {
              id: "preview-inc-transfer",
              text: "🚤 Return speedboat transfers between Velana International Airport and the resort",
              included: true,
              details: "",
            },
            {
              id: "preview-inc-hotel",
              text: "🏨 10 nights in a Sunset Overwater Villa at Sheraton Maldives Full Moon Resort & Spa",
              included: true,
              details: "",
            },
            {
              id: "preview-inc-meals",
              text: "Meal basis: All Inclusive — dining, drinks, and selected activities included",
              included: true,
              details: "",
            },
          ],
        },
        {
          id: "preview-inclusions-extras",
          category: "Honeymoon Extras",
          items: [
            {
              id: "preview-inc-welcome",
              text: "🥂 Complimentary honeymoon welcome amenities on arrival",
              included: true,
              details: "",
            },
            {
              id: "preview-inc-snorkel",
              text: "🤿 Snorkelling equipment and non-motorised water sports",
              included: true,
              details: "",
            },
          ],
        },
      ],
    },
  };
}
